import React, { useCallback, useEffect, useState, lazy, memo } from 'react';
export const SpecialOffer = () => {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    // Get stored value from localStorage or use default on initial render
    return parseInt(localStorage.getItem('copiesLeft') || '374');
  });
  // Memoize the update function to prevent unnecessary re-renders
  const decreaseCopies = useCallback(() => {
    setCopiesLeft(prevCount => {
      // Random decrease between 1-3
      const decrease = Math.floor(Math.random() * 3) + 1;
      const newCount = Math.max(prevCount - decrease, 5); // Don't go below 5
      // Store in localStorage
      localStorage.setItem('copiesLeft', newCount.toString());
      return newCount;
    });
  }, []);
  useEffect(() => {
    // Set interval with memoized function
    const interval = setInterval(decreaseCopies, 3000);
    return () => clearInterval(interval);
  }, [decreaseCopies]);
  return <div id="offer" className="py-16 bg-gradient-to-br from-blue-100 via-white to-red-100 relative" data-id="element-154">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-155">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-156"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-157">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-158">
          <span className="text-blue-700 mr-2" data-id="element-159">★</span>
          Special American Values Offer
          <span className="text-red-700 ml-2" data-id="element-160">★</span>
        </h2>
        <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-12 relative overflow-hidden" data-id="element-161">
          {/* Patriotic corner ribbon */}
          <div className="absolute top-0 right-0 w-32 h-32 overflow-hidden" data-id="element-162">
            <div className="absolute top-0 right-0 transform translate-x-12 -translate-y-2 rotate-45 w-40 h-10 bg-red-700 text-white text-sm font-bold flex items-center justify-center shadow-lg border border-white z-20" data-id="element-163">
              AMERICAN MADE
            </div>
          </div>
          {/* Countdown banner */}
          <div className="bg-red-600 text-white text-center py-2 px-4 rounded-md mb-6 shadow-md" data-id="element-164">
            <p className="font-bold" data-id="element-165">
              URGENT: Only{' '}
              <span className="text-yellow-300 text-xl" data-id="element-166">{copiesLeft}</span>{' '}
              copies left at this price!
            </p>
          </div>
          {/* Book image - only shown on mobile */}
          <div className="md:hidden mb-6" data-id="element-167">
            <div className="relative" data-id="element-168">
              <div className="absolute inset-0 rounded-md bg-gradient-to-tr from-red-700/20 via-white/20 to-blue-700/20" data-id="element-169"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inq4dLe15a2qVGibMXnZAc/Charlie_kirk_book_cover.png" alt="Remembering Charlie Kirk Book Cover" className="w-full max-w-xs mx-auto shadow-xl rounded-md relative z-10" loading="lazy" width="300" height="450" data-id="element-170" />
            </div>
          </div>
          {/* Product options - full width */}
          <div className="flex flex-col gap-6 mb-6" data-id="element-171">
            {/* Digital Option */}
            <div className="w-full border-2 border-blue-700 rounded-lg p-6 bg-blue-50 shadow-md flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-172">
              <div data-id="element-173">
                <h3 className="text-xl font-bold text-blue-800 mb-2" data-id="element-174">
                  Digital Copy
                </h3>
                <p className="text-xl line-through text-gray-500" data-id="element-175">$47.97</p>
                <p className="text-3xl font-bold text-red-700" data-id="element-176">$19.97</p>
                <p className="text-green-700 font-medium mt-2" data-id="element-177">
                  Instant Download
                </p>
                <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-178">
                  <p className="font-medium text-gray-800" data-id="element-179">
                    Includes 1 FREE Bonus!
                  </p>
                </div>
              </div>
              <div className="mt-4 md:mt-0 md:ml-4" data-id="element-180">
                <a href="https://www.voicesoffreedomusa.com/cart/47787658150131:1" className="inline-block w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-8 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-181">
                  Get Digital Copy Now
                </a>
              </div>
            </div>
            {/* Physical Option */}
            <div className="w-full border-2 border-red-700 rounded-lg p-6 bg-red-50 shadow-md relative flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-182">
              {/* BEST DEAL Badge */}
              <div className="absolute -top-3 -right-3 z-20" data-id="element-183">
                <div className="bg-blue-700 text-white text-xs font-bold px-3 py-1 rounded-full transform shadow-lg border border-white" data-id="element-184">
                  BEST DEAL
                </div>
              </div>
              <div data-id="element-185">
                <h3 className="text-xl font-bold text-red-800 mb-2" data-id="element-186">
                  Physical Copy
                </h3>
                <p className="text-xl line-through text-gray-500" data-id="element-187">$67.97</p>
                <p className="text-3xl font-bold text-red-700" data-id="element-188">$34.97</p>
                <p className="text-amber-700 font-medium mt-2" data-id="element-189">
                  Shipping: 14 days (high demand)
                </p>
                <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-190">
                  <p className="font-medium text-gray-800" data-id="element-191">
                    Includes 2 FREE Bonuses!
                  </p>
                </div>
              </div>
              <div className="mt-4 md:mt-0 md:ml-4" data-id="element-192">
                <a href="https://www.voicesoffreedomusa.com/cart/47787656773875:1" className="inline-block w-full bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-193">
                  Order Physical Copy
                </a>
              </div>
            </div>
            {/* Premium Hardcover Option */}
            <div className="w-full border-2 border-yellow-600 rounded-lg p-6 bg-amber-50 shadow-md relative flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-194">
              {/* PREMIUM Badge */}
              <div className="absolute -top-3 -right-3 z-20" data-id="element-195">
                <div className="bg-yellow-600 text-white text-xs font-bold px-3 py-1 rounded-full transform shadow-lg border border-white" data-id="element-196">
                  PREMIUM
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center gap-4" data-id="element-197">
                <div className="md:w-1/3 my-2" data-id="element-198">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qgkkGRAZ38gXZGwtmSAeKn/Generated_Image_September_18%2C_2025_-_10_53AM.png" alt="Premium Hardcover Edition" className="w-full rounded-md shadow-sm" loading="lazy" width="200" height="300" data-id="element-199" />
                </div>
                <div className="md:w-2/3" data-id="element-200">
                  <h3 className="text-xl font-bold text-blue-800 mb-2" data-id="element-201">
                    Premium Hardcover
                  </h3>
                  <p className="text-xl line-through text-gray-500" data-id="element-202">$127.97</p>
                  <p className="text-3xl font-bold text-red-700" data-id="element-203">$94.97</p>
                  <p className="text-amber-700 font-medium mt-2" data-id="element-204">
                    Shipping: 14 days (high demand)
                  </p>
                  <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-205">
                    <p className="font-medium text-gray-800" data-id="element-206">
                      Includes 3 FREE Bonuses!
                    </p>
                  </div>
                  <div className="mt-4" data-id="element-207">
                    <a href="https://www.voicesoffreedomusa.com/cart/47787655856371:1" className="inline-block w-full bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-8 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-208">
                      Order Premium Edition
                    </a>
                  </div>
                </div>
              </div>
              <div className="mt-4 md:mt-0 md:ml-4" data-id="element-209"></div>
            </div>
            {/* Super Bundle Option */}
            <div id="patriot-vault-bundle" className="w-full border-2 border-red-800 rounded-lg p-6 bg-red-50 shadow-md relative flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-210">
              {/* SUPER BUNDLE Badge */}
              <div className="absolute -top-3 -right-3 z-20" data-id="element-211">
                <div className="bg-red-800 text-white text-xs font-bold px-3 py-1 rounded-full transform shadow-lg border border-white" data-id="element-212">
                  SUPER BUNDLE
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:items-center gap-4" data-id="element-213">
                <div className="md:w-1/3 my-2" data-id="element-214">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6BsEXS48hdveVBJWMo5kfk/Super_bundle_%28remembering%29.png" alt="The Patriot Vault - Collector's Edition" className="w-full rounded-md shadow-sm" loading="lazy" width="200" height="300" data-id="element-215" />
                </div>
                <div className="md:w-2/3" data-id="element-216">
                  <div className="flex items-center" data-id="element-217">
                    <h3 className="text-xl font-bold text-red-800 mb-2" data-id="element-218">
                      The Patriot Vault - Collector's Edition
                    </h3>
                    <span className="ml-2 bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 rounded" data-id="element-219">
                      40% OFF
                    </span>
                  </div>
                  <p className="text-xl line-through text-gray-500" data-id="element-220">$419.97</p>
                  <p className="text-3xl font-bold text-red-700" data-id="element-221">$251.37</p>
                  <p className="text-amber-700 font-medium mt-2" data-id="element-222">
                    Shipping: Priority (Limited Quantity Available)
                  </p>
                  <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-223">
                    <p className="font-medium text-gray-800 mb-2" data-id="element-224">
                      Complete 5-Item Collection Includes:
                    </p>
                    <ul className="text-sm text-gray-700 space-y-1 pl-5 list-disc" data-id="element-225">
                      <li data-id="element-226">Trump & Charlie Kirk Limited Edition Art</li>
                      <li data-id="element-227">Voices of Freedom: (Premium Hardcover)</li>
                      <li data-id="element-228">FREEDOM™ Mug</li>
                      <li data-id="element-229">Make America Charlie Kirk T-Shirt (Signature Red)</li>
                      <li data-id="element-230">
                        Make America Charlie Kirk Fitted Hat (Signature Red)
                      </li>
                    </ul>
                  </div>
                  <div className="mt-4" data-id="element-231">
                    <a href="https://voicesoffreedomusa.com/products/the-patriot-vault-charlie-kirk-collector-s-edition-1" className="inline-block w-full bg-red-800 hover:bg-red-900 text-white font-bold py-3 px-8 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-232">
                      Claim Super Bundle Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 border-l-4 border-blue-700 p-4 mb-6" data-id="element-233">
            <p className="text-lg font-medium" data-id="element-234">
              But there's a catch: only a limited number of copies are being
              released at this price for freedom-loving Americans.
            </p>
          </div>
          {/* Added action text */}
          <div className="text-center mb-10" data-id="element-235">
            <h3 className="text-xl md:text-2xl font-bold mb-6 mt-8" data-id="element-236">
              <span className="text-red-700" data-id="element-237">★</span> Take action now{' '}
              <span className="text-blue-700" data-id="element-238">★</span>
            </h3>
            <p className="text-base md:text-lg font-medium text-gray-800" data-id="element-239">
              👉 Click below to claim your copy before this patriotic launch
              discount expires.
            </p>
          </div>
          {/* Re-added CTA button at the bottom */}
          <div className="flex justify-center mt-8" data-id="element-240">
            <a href="#patriot-vault-bundle" className="bg-[#B42C24] text-white text-xl font-bold py-4 px-10 rounded-lg shadow-lg w-full md:w-auto text-center relative overflow-hidden group transition-all duration-300" style={{
            position: 'relative',
            zIndex: 1
          }} onClick={e => {
            e.preventDefault();
            document.getElementById('patriot-vault-bundle')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-241">
              <span className="relative z-10" data-id="element-242">
                Get My Copy Now — Limited Time Offer
              </span>
              <span className="absolute inset-0 bg-blue-700 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300 ease-in-out" style={{
              zIndex: -1
            }} data-id="element-243"></span>
            </a>
          </div>
        </div>
      </div>
    </div>;
};